import React from 'react';
import './blog-post.css';

import pm1 from './pictures/pm1.jpeg';
import pm2 from './pictures/pm2.jpeg';
import pm3 from './pictures/pm3.jpg';
import pm4 from './pictures/pm4.jpg';
import pm5 from './pictures/pm5.jpeg';
import pm6 from './pictures/pm6.jpg';
import pm7 from './pictures/pm7.jpeg';

const PMTalks = () => {

  return (
    <div>
      <div className='blog__container'>
        <div class="row">
            <div class="column">
                <header>
                    <h3 class="site-post-title rounded title-padding">
                        <b>WiC at Work</b>
                    </h3>
                </header>
                <section>
                    <h2>PM Talks with Microsoft Recap</h2>
                    <p class="site-post-meta">May 14th, 2024</p>
                    <hr></hr>
                </section>
                <section>
                    <p>
                    Hi WiC members! 
                    <br></br>
                    <br></br>
                    What an amazing evening with Microsoft PMs!
                    <br></br>
                    <br></br>
                    On May 14th, WiC hosted a Microsoft PM Talks event featuring 3 amazing women product managers at different 
                    stages of their careers who shared their experiences in product management and gave students a glimpse into 
                    what a day in the life of a PM looks like! Students also participated in a skills assessment activity to 
                    understand how their skills and values can strengthen their PM careers! At the end of the event, 
                    students got the opportunity to ask questions to our speakers about their journeys and 
                    getting started with product management careers.

                    <br></br>
                     
                    </p>
                    <img src={pm1} alt="Group picture"/>
                    <img src={pm2} alt="Group picture"/>
                    <img src={pm3} alt="Group picture"/>
                    <img src={pm4} alt="Group picture"/>
                    <img src={pm5} alt="Group picture"/>
                    <img src={pm6} alt="Group picture"/>
                    <img src={pm7} alt="Group picture"/>
                
                </section>
            </div>
        </div>      
      </div>
    </div>
  );
};

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();
export default PMTalks;

